import React from "react";
import { BsArrowRight } from "react-icons/bs";
import { Link } from "react-router-dom";

const ProjectsDesktop = ({ id, img, display, header, subHeader, language }) => {
  return (
    <>
      <div
        style={{
          // display: "inline-block",
          border: "2px solid #ABB2BF",
          height: "min-content",
          maxWidth: "300px",
          margin: "3% 0",
          //   height: "auto",
        }}
      >
        <div>
          <img
            src={img}
            alt=""
            style={{ width: "300px", height: "auto", maxHeight: "300px" }}
          />
        </div>

        <div>
          <span
            style={{
              display: "inline-block",
              flexWrap: "wrap",
              width: "100%",
              color: "#ABB2BF",
              border: "2px solid #ABB2BF",
              fontWeight: "bolder",
            }}
          >
            {[...language]}
          </span>
        </div>
        <div
          style={{
            marginLeft: "3%",
            display: "flex",
            flexDirection: "column",
            // flexWrap: "wrap",
            alignItems: "start",
            justifyContent: "start",
            gap: "3%",
            width: "auto",
            padding: "2% 5% 3% 0",
          }}
        >
          <h2 style={{ color: "white", fontWeight: "bolder", marginTop: "4%" }}>
            {header}
          </h2>
          <h3 style={{ color: "#ABB2BF", textAlign: "justify" }}>
            {subHeader}
          </h3>
          <div>
            <Link to={display}>
              <button
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100px",
                  alignItems: "center",
                  border: "1px solid #C778DD",
                  marginTop: "6%",
                  marginBottom: "13%",
                  padding: "8% 17%",

                  // borderRadius: "3%",
                }}
              >
                <span
                  style={{
                    color: "white",
                    marginLeft: "5%",
                    fontWeight: "bolder",
                  }}
                >
                  Live
                </span>
                <BsArrowRight style={{ color: "white" }} />
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectsDesktop;
